import { useMemo } from 'react';

import { useAuth } from '@/js/libs/use-auth';

import { IMPERSONATED_USER_HEADER_NAME, SELECTED_COMPANY_HEADER_NAME } from '../constants.ts';

// Builds the headers every request carries: the token; the impersonated user once the logged user is loaded, so the
// logged user always loads as themselves; and the selected company only once the identity carries it, that is once the
// identity loaded for the company is applied.
export const useRequestHeaders = (): Record<string, string> => {
  const { identity, impersonatedUser, loggedUser, selectedCompany, token } = useAuth();
  const impersonatedEmail = loggedUser && impersonatedUser ? impersonatedUser.email : null;
  const appliedCompany = selectedCompany && identity?.company.id === selectedCompany.id ? selectedCompany : null;

  return useMemo(() => {
    const requestHeaders: Record<string, string> = {
      'Cache-Control': 'no-cache',
      'If-Modified-Since': 'Sun, 06 Oct 2013 01:16:45 GMT',
    };
    if (token) {
      requestHeaders.Authorization = `Bearer ${token}`;
    }
    if (impersonatedEmail) {
      requestHeaders[IMPERSONATED_USER_HEADER_NAME] = impersonatedEmail;
    }
    if (appliedCompany) {
      requestHeaders[SELECTED_COMPANY_HEADER_NAME] = window.btoa(
        JSON.stringify({
          id: appliedCompany.id,
          companyUUID: appliedCompany.companyUUID,
        }),
      );
    }

    return requestHeaders;
  }, [appliedCompany, impersonatedEmail, token]);
};
